/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.9",
    versionName: "0.2.0-nightly.2026.4.9",
    versionChannel: "nightly",
    buildDate: "2026-04-09T00:11:53.083Z",
    commitHash: "c13ce972f51053ff20445bff03f4694952950bfa",
};
